import type { HttpEvent, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import type { Observable } from "rxjs";
import { finalize } from "rxjs";
import { PendingRequestsService } from "../services/pending-requests.service";

export function pendingRequestsInterceptor(req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
  const pending = inject(PendingRequestsService);
  pending.increment();

  return next(req).pipe(finalize(() => pending.decrement()));
}

